<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5">
            </b-media>
        </base-header>
        <b-container class="container-fluid mt--7">

            <b-row>
                <b-col col sm="12">
                    <b-card no-body>
                        <div class="card shadow">
                            <div class="card-header bg-transparent">
                                <div>
                                    <h3 class="float-left mb-0">
                                        {{ $tc('message.followUp') }}
                                    </h3>
                                </div>

                                <div class="card-body">
                                    <div class="card-title ml-3">
                                    </div>
                                    <b-container>
                                        <section class="container" id="followup">
                                            <div class="row followup-header my-2 mb-4">
                                                <div class="col-md-4">
                                                    <b-button
                                                            @click="onAddClick"
                                                            class="followup-add"
                                                    >
                                                        <i class="fa fa-plus edit-icon"></i>
                                                        {{ $t('message.add') }}
                                                    </b-button>
                                                </div>

                                                <div class="col-md-7 d-inline-block ml-1">
                                                    <b-input-group
                                                            size="md"
                                                            class="mb-3"
                                                    >
                                                        <b-form-input
                                                                type="text"
                                                                size="lg"
                                                                class="p-2 h-100"
                                                                :placeholder="$t('message.searchPatient') + '...'"
                                                                v-model="filterCriteria"
                                                        ></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button
                                                                    size="sm"
                                                                    text="Button"
                                                                    variant="primary"
                                                            >
                                                                <i class="fa fa-search"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>
                                            </div>
                                            <div v-if="filterCriteria.length <= 0" class="row followup-category-content">
                                                <div
                                                        v-for="(followUpCategory, key) in followUpCategories"
                                                        :key="key"
                                                        class="col-md-3 followup-category-item"
                                                        @click="goToOneCategory(followUpCategory.slug)"
                                                >
                                                    <div>
                                                        <div class="followup-category-item-title mb-4">
                                                            <h3>{{ followUpCategory.nom }}</h3>
                                                        </div>
                                                        <div class="followup-category-item-icon">
                                                            <i :class="`fa ${followUpCategory.icon} fa-5x`"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="row followup-category">
                                                <div
                                                        :class="`row ${followUpArray.length === 0 ? 'p-3' : ''}`"
                                                >
                                                    <template
                                                        v-if="followUpArray.length > 0"
                                                    >
                                                        <div
                                                            v-for="followUpItem in followUpArray"
                                                            :key="followUpItem.id"
                                                            class="col-md-4 mb-4"
                                                        >
                                                            <div class="followup-card-item-wrapper" v-if="followUpItem.dossier!==null && followUpItem.dossier.patient!==null && followUpItem.dossier.patient.user!==null">
                                                                <div class="followup-card-item">
                                                                    <div
                                                                            class="title"
                                                                            @click="goToOneCategory(followUpItem.categorie ? followUpItem.categorie.slug : null)"
                                                                    >
                                                                        <p>{{ followUpItem.dossier.patient.user.nom }}</p>
                                                                    </div>
                                                                    <div class="message">
                                                                        <p>{{ followUpItem.motifs }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <template v-else>
                                                        <p class="mt-2 ml-2">
                                                            <i>{{ $t('message.noSearchResult') }}</i>
                                                        </p>
                                                    </template>
                                                </div>
                                            </div>
                                            <div class="row appointment-table-footer">

                                            </div>
                                        </section>
                                    </b-container>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
	import * as _ from "lodash";
	import router from '../../router/router';

    export default {
        name: "FollowUpCategories",
        computed: {
            ...mapGetters([
            	"followed",
                "followUpCategories",]),
        },

        data() {
            return {
				followedUpToDelete: '',
				filterCriteria: '',
				followUpArray: []
            };
        },
        watch: {
			followUpCategories: function (n, o) {
				// console.log('n => ', n);
			},
			followed: function (n, o) {
				// console.log('followed => ', n);
			},
			filterCriteria: async function (newValue, oldValue) {
                if(newValue.length==1){
                    await this.getSearchSuivi(newValue)
				    this.handleFilter(newValue);
                }
                if(newValue.length>1){
                    this.handleFilter(newValue);
                }
                
			}
        },
        methods: {
			onAddClick() {
				event.preventDefault();
				router.push({ name: 'add-follow-up' });
			},

			getListOfFollowUpCategories(){
				this.$store.dispatch('getFollowUpCategories', {args: {}});
			},

            goToOneCategory(slug) {
				if (slug)
				    router.push({ name: 'follow-up-category', params: {followUpCategorySlug: slug} });
            },

			onGoToMedicalFile(slug) {
				router.push({ name: 'medical-file', params: {file: slug} });
			},

			handleFilter(value) {
				if (value && value !== '') {
                    if(value.length==1){
                        this.followUpArray = this.followed;
                    }
                    if(value.length>1){
                        this.followUpArray = this.followed.filter(app => {
                            let result = false;
                            if (app.motifs) {
                                result = result || app.motifs.toLowerCase().includes(value.toLowerCase())
                            }
                            if (app.dossier !== null && app.dossier.patient.user!==null) {

                                if (app.dossier.patient.user.nom) {
                                    result = result || app.dossier.patient.user.nom.toLowerCase().includes(value.toLowerCase())
                                }
                        
                                if (app.dossier.patient.user.prenom) {
                                    result = result || app.dossier.patient.user.prenom.toLowerCase().includes(value.toLowerCase())
                                }
                            }
                            return result;
                        
                        
                        });
                    }
				} else {
					this.followUpArray = this.followed;
				}
			},

			getFollowed(){
				this.$store.dispatch('getFollowed', {args: {}});
			},

            async getSearchSuivi(value) {
                // console.log("juste pour vérifier");
                let args = {
                    suivi: value
                };

                await this.$store.dispatch("getSearchFollowed", {
                    args : args
                });
            },
        },
        mounted() {
            this.getListOfFollowUpCategories();
			// this.getFollowed();
        }
    }
</script>

















<style scoped lang="scss">
    $primary-color: #2dcecc;
    $gray-color: #ebecf0;
    $white: #fff;
    $black: #121212;

    .followup-category-content {
        .followup-category-item {
            padding-top: 30px;
            /*background: #2dcecc;*/
            background: linear-gradient(30deg, rgba(0, 173, 167, 1) 0%, rgba(45, 206, 137, 1) 35%, #2dcecc 100%);
            border-radius: 10px;
            height: 250px;
            justify-content: center;
            /*align-items: center;*/
            display: flex;
            margin-left: 2rem;
            margin-bottom: 2rem;

            &:hover {
                transform: scale(1.005);
                cursor: pointer;
                /*transition: all .2s;*/
            }

            .followup-category-item-title {
                margin-bottom: 1rem;
                h3 {
                    color: white !important;
                    font-weight: 600;
                    font-size: 20px;

                    &:first-letter {
                        text-transform: uppercase;
                    }
                }
            }

            .followup-category-item-icon {
                text-align: center;
                color: white;
            }
        }
    }

    .followup-card-item {
        $padding-left: 15px;

        position: relative;
        background: $white;
        padding: $padding-left;
        /*border: 0.5px solid rgba(0, 0, 0, 0.1);*/
        border-radius: 9px;
        box-shadow: 0px 0px 17px 0px rgba(82, 83, 105, 0.05);

        /*margin: 0 10px;*/
        /*margin-bottom: 20px;*/
        /*width: 225px;*/

        p {
            margin-bottom: 0;
        }

        .title {
            margin-bottom: 4px;
            position: relative;

            &:first-letter {
                text-transform: uppercase;
            }

            &:hover {
                cursor: pointer !important;
            }

            &:after {
                content: ' ';
                position: absolute;
                bottom: 0;
                left: -1%;
                width: 100%;
                height: 1px;
                background: #8080807d;
            }
        }

        .message {
            p {
                color: #808080ab;
                font-size: 15px;
                white-space: nowrap;
                width: 144px;
                text-overflow: ellipsis;
                overflow: hidden;
                margin-bottom: 10px;
            }
        }

        .threedot {
            position: absolute;
            top: 0;
            right: $padding-left;
            cursor: pointer;

            /*.threedot-link {
                span {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: $primary-color;
                    margin-left: 3px;
                    border-radius: 50%;
                }

                &:hover ~ .followup-action {
                    right: 0;
                    opacity: 1;
                }
            }*/

            span {
                display: inline-block;
                width: 4px;
                height: 4px;
                background: $primary-color;
                margin-left: 3px;
                border-radius: 50%;
            }

            &:hover {
                span {
                    background: #44cb8c;
                    border-color: $black;
                }

                .followup-action {
                    right: 0;
                    opacity: 1;
                }
            }

            .followup-action {
                background: $white;
                position: absolute;
                top: 25px;
                right: -100px;
                opacity: 0;
                transition: all .3s;

                a {
                    color: $black;
                    display: block;
                    padding: 5px 15px;
                    transition: all .3s;
                    font-weight: 600;

                    &:hover {
                        background: $gray-color;
                        color: $primary-color;
                    }
                }
            }
        }

        .label-container {
            position: absolute;
            bottom: -10px;
            right: 15px;
            max-height: 25px;
            max-width: 140px;
            overflow: hidden;

            .label {
                background: $primary-color;
                border-radius: 25px;
                padding: 1px 5px;
                display: inline-block;
                margin-left: 4px;
                cursor: pointer;

                p {
                    font-size: 0.8rem;
                    color: white;
                    font-weight: 600;
                    white-space: nowrap;
                    width: 13px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    text-align: center;
                }
            }
        }

        .followup-switcher {
            position: absolute;
            bottom: -10px;
            left: 0;
            max-height: 25px;
            max-width: 25px;
            overflow: hidden;
            border-radius: 50%;

            .followup-switcher--btn {
                background: $primary-color;
                border-radius: 50%;
                padding: 1px 5px;
                cursor: pointer;

                i {
                    color: $white;
                }
            }
        }
    }

    .followup-category {
        max-height: 400px;
        overflow: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-track {
            /*box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);*/
        }

        &::-webkit-scrollbar-thumb {
            background-color: #5e72e4 !important;
            outline: 1px solid slategrey;
            border-radius: 20px;
        }
    }
</style>
